import { FormControlLabel, Radio, RadioGroup, SxProps } from '@mui/material';
import { Controller, Control, FieldValues } from 'react-hook-form';

export interface RadioFieldProps {
  id: string;
  label?: string;
  name?: string;
  defaultValue?: unknown;
  required?: boolean;
  control: Control<FieldValues, any>;
  buttons: { label: string; value: unknown }[];
  row?: boolean;
  onClick?: (value: unknown) => void;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps;
}

export const RadioField = ({
  id,
  name,
  defaultValue,
  required = false,
  buttons,
  control,
  row = false,
  onClick,
  disabled = false,
  onChange,
  sx,
}: RadioFieldProps) => {
  return (
    // controller is built in to react-hook-form and it allows your input to be registered with useForms internal state.
    <Controller
      rules={{ required }}
      control={control}
      name={name ?? id}
      defaultValue={defaultValue}
      render={({ field }) => (
        <RadioGroup
          {...field}
          onChange={(e) => {
            onChange && onChange(e);
            field.onChange(e.target.value);
          }}
          row={row}
          aria-labelledby="group"
          sx={sx}
          defaultValue={defaultValue}
          name={name}
        >
          {buttons.map(
            (
              { label, value }: { label: string; value: unknown },
              index: number
            ) => (
              <FormControlLabel
                key={index}
                value={value}
                control={
                  <Radio
                    sx={{
                      '&, &.Mui-checked': {
                        color: '#3F51B5',
                      },
                    }}
                    onClick={() => onClick && onClick(value)}
                  />
                }
                label={label}
                disabled={disabled}
              />
            )
          )}
        </RadioGroup>
      )}
    />
  );
};
